export type CopyCoordinates = {
    x: number,
    y?: number,
    z: number
}

export function getDefaultCoordinateText(coordinates: CopyCoordinates, separator: string): string {
    const values = coordinates.y === undefined
        ? [coordinates.x, coordinates.z]
        : [coordinates.x, coordinates.y, coordinates.z]
    return values.map(value => value.toFixed(0)).join(separator)
}

export function formatCoordinateCopy(coordinates: CopyCoordinates, defaultText: string, template: string): string {
    const trimmedTemplate = template.trim()
    if (trimmedTemplate === '') {
        return defaultText
    }

    const replacements: Record<string, string> = {
        x: coordinates.x.toFixed(0),
        y: coordinates.y?.toFixed(0) ?? '~',
        z: coordinates.z.toFixed(0),
        '~': '~'
    }
    return trimmedTemplate.replace(/<(x|y|z|~)>/gi, (_match, placeholder: string) => replacements[placeholder.toLowerCase()]).trim()
}
